<div class="d-flex row menu-config-form mb-2">
  <div class="col-md-4 col-12 form-group-mobile">
    <label>{{'menu_tab_name' | translate}} <i class="bi bi-info-circle text-primary"
        [ngbTooltip]="tooltipData.label | translate" placement="top"></i></label>
    <input type="text" class="form-control" [id]="'navLabel' + navIndex"
      [placeholder]="'ph_enter_label_link' | translate" [(ngModel)]="navItem.label" />
  </div>
  <div class="col-md-4 col-12 form-group-mobile">
    <label>{{'menu_target' | translate}} <i class="bi bi-info-circle text-primary"
        [ngbTooltip]="tooltipData.target | translate" placement="top"></i></label>
    <app-dynamic-select-input [itemsList]="targetList" [selectedItems]="navItem.target" [multiple]="false"
      [showCloseButton]="false" [placeholder]="'ph_link_target' | translate" [defaultBindLabel]="'label'"
      (newSelectEvent)="onTargetChange($event, navItem)">
    </app-dynamic-select-input>
  </div>
  <div class="col-md-4 col-12 form-group-mobile">
    <div *ngIf="navItem.target === 'INTERNAL_PAGE'">
      <label>{{'menu_pages' | translate}} <i class="bi bi-info-circle text-primary"
          [ngbTooltip]="tooltipData.path | translate" placement="top"></i></label>
      <app-dynamic-select-input [itemsList]="pagesListDll" [selectedItems]="navItem.path" [bindId]="'path'"
        [multiple]="false" [showCloseButton]="false" [placeholder]="'ph_link_path' | translate"
        [defaultBindLabel]="'label'" (newSelectEvent)="onInternalPageChange($event)">
      </app-dynamic-select-input>
    </div>
    <div *ngIf="navItem.target === 'EXTERNAL_PAGE'">
      <div class="form-group">
        <label class="font-weight-normal">{{'menu_external_url' | translate}}<i class="bi bi-info-circle text-primary"
            [ngbTooltip]="tooltipData.url | translate" placement="top"></i></label>
        <input type="text" class="form-control" [placeholder]="'ph_enter_external_link' | translate"
          [(ngModel)]="navItem.path" />
      </div>
    </div>
    <div *ngIf="navItem.target === 'PLP' && navItem['filter']">
      <label>{{'menu_filter_by' | translate}} <i class="bi bi-info-circle text-primary"
          [ngbTooltip]="tooltipData.filterBy | translate" placement="top"></i></label>
      <app-dynamic-select-input [itemsList]="plpFilterList" [selectedItems]="navItem['filter'].by" [multiple]="false"
        [showCloseButton]="false" [placeholder]="'ph_filter_by' | translate" [defaultBindLabel]="'label'"
        (newSelectEvent)="onFilterChange($event)">
      </app-dynamic-select-input>
    </div>
    <div *ngIf="navItem.target === 'PDP' && navItem['filter']">
      <label>{{'menu_filter_by' | translate}} <i class="bi bi-info-circle text-primary"
          [ngbTooltip]="tooltipData.filterBy | translate" placement="top"></i></label>
      <app-dynamic-select-input [itemsList]="pdpFilterList" [selectedItems]="navItem['filter'].by" [multiple]="false"
        [showCloseButton]="false" [placeholder]="'ph_filter_by' | translate" [defaultBindLabel]="'label'"
        (newSelectEvent)="onFilterChange($event)">
      </app-dynamic-select-input>
    </div>
  </div>
</div>
<div *ngIf="navItem.target === 'PLP' || navItem.target === 'PDP'" class="mb-2">
  <div *ngIf="navItem['filter'] && navItem['filter'].by == 'PRODUCT_ID'">
    <app-dynamic-property-filter-by [siteId]="siteId" [filterObject]="navItem['filter']" [targetObject]="navItem.target"
      [showFilterBy]="false" [menuProposit]="true">
    </app-dynamic-property-filter-by>
  </div>
  <div *ngIf="navItem['filter'] &&(navItem['filter'].by == 'PRODUCT_IDS')">
    <app-dynamic-property-filter-by [siteId]="siteId" [filterObject]="navItem['filter']" [targetObject]="navItem.target"
      [showFilterBy]="false" [menuProposit]="true">
    </app-dynamic-property-filter-by>
  </div>
  <div *ngIf="navItem['filter'] &&(navItem['filter'].by == 'CATEGORY_IDS')">
    <app-dynamic-property-filter-by [siteId]="siteId" [filterObject]="navItem['filter']" [targetObject]="navItem.target"
      [showFilterBy]="false" [menuProposit]="true">
    </app-dynamic-property-filter-by>
  </div>
</div>